import axios from "axios";
import Vue from "vue";

var instance = axios.create({
    baseURL: window.location.origin,
});

export default {
    namespaced: true,
    state: {
        regionalSales: [],
        lstRSMAccess: [],
        rsmAccess: {
            regionalSalesUserAccessID: 0,
            rsmCode: '',
            name: '',
            email: '',
            reportAccess: '',
        },
        regionalSalesManager: {
            rsmID: 0,
            rsmCode: '',
            rsmName: '',
            listAgentCodes: [],
            listEmail: []
        },
        filter: {
            rsmCode: ""
        }
    },
    mutations: {
        SET_RegionalSales(state, value) {
            state.regionalSales = value
        },
        SET_RegionalSalesManager(state, value) {
            state.regionalSalesManager = Object.assign({}, value);
        },
        RESET_RegionalSalesManager(state) {
            state.regionalSalesManager = {
                rsmID: 0,
                rsmCode: '',
                rsmName: '',
                listAgentCodes: [],
                listEmail: []
            }
        },
        SET_LstRSMAccess(state, data) {
            state.lstRSMAccess = data
        },
        RESET_LstRSMAccess(state) {
            state.lstRSMAccess = []
        },
        RESET_RSMAccess(state) {
            state.rsmAccess = {
                regionalSalesUserAccessID: 0,
                rsmCode: '',
                name: '',
                email: '',
                reportAccess: '',
            }
        },
        UPDATE_RSMAccess(state, data) {
            var index = state.lstRSMAccess.findIndex((obj => obj.email == data.email));

            if (index >= 0) {
                Vue.set(state.lstRSMAccess, index, data);
            } else {
                state.lstRSMAccess.push(data);
            }
        },
        UPDATE_RSMAccessByID(state, data) {
            var index = state.lstRSMAccess.findIndex((obj => obj.regionalSalesUserAccessID == data.regionalSalesUserAccessID));

            if (index >= 0) {
                Vue.set(state.lstRSMAccess, index, data);
            } else {
                state.lstRSMAccess.push(data);
            }
        },
        REMOVE_RSMAccess(state, email) {
            var index = state.lstRSMAccess.findIndex((obj => obj.email == email));

            if (index >= 0) {
                state.lstRSMAccess.splice(index, 1);
            }
        },
    },
    getters: {
        filter(state) {
            return state.filter
        },
        regionalSalesManager(state) {
            return state.regionalSalesManager
        },
        rsmAccess(state) {
            return state.rsmAccess
        }
    },
    actions: {
        GetRegionalSales({ getters, commit, rootGetters }) {
            var filter = getters.filter;
            commit('SET_RegionalSales', [])

            return new Promise((resolve, reject) => {
                instance
                    .get("api/regionalsales?rsmCode=" + filter.rsmCode, {
                        headers: {
                            Authorization: "Bearer " + rootGetters.token,
                        }
                    })
                    .then(async function (response) {
                        commit('SET_RegionalSales', response.data)
                        resolve(true);
                    })
                    .catch(function (error) {
                        reject(error.response);
                    });
            });
        },
        AddRegionalSalesManager({ getters, rootGetters }) {
            var regionalSalesManager = getters.regionalSalesManager;
            return new Promise((resolve, reject) => {
                instance
                    .post("api/regionalSales", regionalSalesManager, {
                        headers: {
                            Authorization: "Bearer " + rootGetters.token,
                        }
                    })
                    .then(async function (response) {
                        resolve(true);
                    })
                    .catch(function (error) {
                        reject(error.response);
                    });
            });
        },
        UpdateRegionalSalesManager({ getters, rootGetters }) {
            var regionalSalesManager = getters.regionalSalesManager;
            return new Promise((resolve, reject) => {
                instance
                    .put("api/regionalSales/" + regionalSalesManager.rsmid, regionalSalesManager, {
                        headers: {
                            Authorization: "Bearer " + rootGetters.token,
                        }
                    })
                    .then(async function (response) {
                        resolve(true);
                    })
                    .catch(function (error) {
                        reject(error.response);
                    });
            });
        },
        DeleteRegionalSalesManager({ getters, rootGetters }) {
            var regionalSalesManager = getters.regionalSalesManager;

            return new Promise((resolve, reject) => {
                instance
                    .delete("api/regionalSales/" + regionalSalesManager.rsmid, {
                        headers: {
                            Authorization: "Bearer " + rootGetters.token,
                        }
                    })
                    .then(async function (response) {
                        resolve(true);
                    })
                    .catch(function (error) {
                        reject(error.response);
                    });
            });
        },
        // RSM User Access Actions
        GetRSMAccess({ commit, rootGetters }, rsmCode) {
            commit('RESET_LstRSMAccess');

            return new Promise((resolve, reject) => {
                instance
                    .get("api/RegionalSales/access?rsmcode=" + rsmCode, {
                        headers: {
                            Authorization: "Bearer " + rootGetters.token,
                        }
                    })
                    .then(async function(response) {
                        commit('SET_LstRSMAccess', response.data)
                        resolve(true);
                    })
                    .catch(function(error) {
                        reject(error.response);
                    });
            });
        },
        AddRSMAccess({ getters, commit, rootGetters }) {
            var rsmAccess = getters.rsmAccess;

            return new Promise((resolve, reject) => {
                instance
                    .post("api/RegionalSales/access", rsmAccess, {
                        headers: {
                            Authorization: "Bearer " + rootGetters.token,
                        }
                    })
                    .then(async function(response) {
                        commit('UPDATE_RSMAccess', response.data)
                        commit('RESET_RSMAccess');
                        resolve(true);
                    })
                    .catch(function(error) {
                        reject(error.response);
                    });
            });
        },
        EditRSMAccess({ getters, commit, rootGetters }) {
            var rsmAccess = getters.rsmAccess;

            return new Promise((resolve, reject) => {
                instance
                    .put("api/RegionalSales/access", rsmAccess, {
                        headers: {
                            Authorization: "Bearer " + rootGetters.token,
                        }
                    })
                    .then(async function(response) {
                        commit('UPDATE_RSMAccessByID', response.data)
                        commit('RESET_RSMAccess');
                        resolve(true);
                    })
                    .catch(function(error) {
                        reject(error.response);
                    });
            });
        },
        DeleteRSMAccess({ commit, rootGetters }, email) {
            return new Promise((resolve, reject) => {
                instance
                    .delete("api/RegionalSales/access?email=" + email, {
                        headers: {
                            Authorization: "Bearer " + rootGetters.token,
                        }
                    })
                    .then(async function(response) {
                        commit('REMOVE_RSMAccess', email)
                        commit('RESET_RSMAccess');
                        resolve(true);
                    })
                    .catch(function(error) {
                        reject(error.response);
                    });
            });
        },
        ResetRSMAccess({ commit, rootGetters }, email) {
            return new Promise((resolve, reject) => {
                instance
                    .put("api/RegionalSales/access/reset/password?email=" + email, '', {
                        headers: {
                            Authorization: "Bearer " + rootGetters.token,
                        }
                    })
                    .then(async function(response) {
                        commit('RESET_RSMAccess');
                        resolve(true);
                    })
                    .catch(function(error) {
                        reject(error.response);
                    });
            });
        },
    },
};